import './Divider-7c6b656a.css';

var classes = {"Divider":"prc-ActionList-Divider-e9gCq"};

export { classes as default };
